import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { LocationSportsResponse } from '@/api/types';

export function useLocationSports(locationId: string | undefined) {
  return useQuery({
    queryKey: ['locationSports', locationId],
    queryFn: () => apiClient<LocationSportsResponse>(`/locations/${locationId}/sports`, { skipAuth: true }),
    enabled: !!locationId,
  });
}
